import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import it from "./i18n/it.json";
import en from "./i18n/en.json";

const resources = {
  it,
  en,
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "it",

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
